/**
 * 当前插件仅在登录引擎组件中使用
 */
import $ from "jquery"
import Qs from "qs"
import { getAllColsUidInLayoutComponent, handleFindLayoutComponentOptions, hasProperty } from "utils"
class loginEngineComponentClass {
  constructor(val) {
    this.content = val
    this.getElement = ""
    this.getElement1 = ""
    this.getElement2 = ""
    this.getElement3 = ""
  }
  async init() {
    const that = this
    this.getElement = this.getElementInLayout(0)
    this.getElement1 = this.getElementInLayout(1)
    this.getElement2 = this.getElementInLayout(2)
    this.getElement3 = this.getElementInLayout(3)
    // console.log('getElement :>>',this.getElement);
    // console.log('this.content :>>',that.content);
    this.height = that.getElement.loginOptions.height
    // 手机号登录
    // this.phoneLogin = that.getElement.loginOptions.phoneLogin
    // if (!this.phoneLogin) {
    //   $(that.content.$el).find(".tabsContainer .tab:nth-child(1)").hide()
    // }
    // 扫码登录
    // this.codeLogin = that.getElement.loginOptions.codeLogin
    // if (!this.codeLogin) {
    //   $(that.content.$el).find(".tabsContainer .tab:nth-child(2)").hide()
    // }
    // 短信验证码登录
    // this.testLogin = that.getElement.loginOptions.testLogin
    // if (!this.testLogin) {
    //   $(that.content.$el).find(".tabsContainer .tab:nth-child(4)").hide()
    // }
    // 机构账户登录
    // this.schoolLogin = that.getElement.loginOptions.schoolLogin
    // if (!this.schoolLogin) {
    //   $(that.content.$el).find(".tabsContainer .tab:nth-child(3)").hide()
    // }
    // 只有一个时隐藏tab
    // let checkBoxList = [this.phoneLogin, this.codeLogin, this.testLogin, this.schoolLogin]
    // let count = checkBoxList.filter(item => item == true)
    // if (count.length > 1) {
    //   $(that.content.$el).find(".tabsContainer").show()
    // } else {
    //   $(that.content.$el).find(".tabsContainer").hide()
    // }
    // 登录方式
    this.loginWay = that.getElement.loginOptions.loginWay || "1"
    if (this.loginWay == "1") {
      // $(that.content.$el).find(".top>div:first-child").show()
      // $(that.content.$el).find(".row").hide()
      // $(that.content.$el)
      //   .find(`.row:nth-child(${that.getElement.loginOptions.activeIndex + 1})`)
      //   .show()
      // that.placeholder = "手机号"
    } else {
      // $(that.content.$el).find(".top>div:first-child").hide()
      // $(that.content.$el).find(".row").hide()
      // $(that.content.$el).find(`.row:nth-child(1)`).show()
      // that.placeholder = "账号"
    }
    that.tipsShowHide()
    setTimeout(() => {
      that.initState()
      // that.telPhoneLogin()
      // that.codeLoginFun()
      // that.schoolIdLogin()
      // that.messageLogin()
      // 修改提示文案
      // $(
      //   `.container_id_${that.getElement.loginMsg.container_id}-rect_id_${that.getElement.loginMsg.rect_id}-uid_${that.getElement.loginUid}-elementInLayoutId_${that.getElement.loginElementInLayout[0].elementInLayoutId} .input-component input`
      // ).attr("placeholder", that.placeholder)
      that.tabClick()
    }, 1000)
  }
  // 获取登录基本组件
  getElementInLayout(index) {
    const loginMsg = {
      container_id: this.content.myid.container_id,
      rect_id: this.content.myid.rect_id
    }
    const rectAttr = this.content.getRectAttribute.call(this.content, loginMsg)
    const loginOptions = [rectAttr.options.rows[index]]
    const loginUid = getAllColsUidInLayoutComponent(loginOptions)[0]
    const loginElementInLayout = handleFindLayoutComponentOptions(loginOptions, loginUid)
    const loginTitleOptions = [rectAttr.options.titleOptions[0].elementOptions]
    return {
      loginOptions: rectAttr.options,
      loginMsg: loginMsg,
      loginUid: loginUid,
      loginElementInLayout: loginElementInLayout,
      loginTitleOptions: loginTitleOptions
    }
  }
  // 初始状态
  initState() {
    const that = this
    // 是否开启双因素安全验证
    const doubleFactor = hasProperty(that.getElement.loginOptions, "doubleFactor")
      ? hasProperty(that.getElement.loginOptions, "doubleFactor")
      : false
    // 是否开启独立密码验证
    const alonePassword = hasProperty(that.getElement.loginOptions, "alonePassword")
      ? hasProperty(that.getElement.loginOptions, "alonePassword")
      : false
  }
  // 隐藏显示错误提示
  tipsShowHide() {
    const that = this
    // 隐藏错误提示
    this.content.$changeOptionsEV(0, "opacity", false, null,{
      uid: this.getElement.loginUid,
      elementInLayoutId: this.getElement.loginElementInLayout[4].elementInLayoutId,
      ...this.getElement.loginMsg
    }, true)
    this.content.$changeOptionsEV(0, "opacity", false, null,{
      uid: this.getElement2.loginUid,
      elementInLayoutId: this.getElement2.loginElementInLayout[5].elementInLayoutId,
      ...this.getElement2.loginMsg
    }, true)
    this.content.$changeOptionsEV(0, "opacity", false, null,{
      uid: this.getElement3.loginUid,
      elementInLayoutId: this.getElement3.loginElementInLayout[5].elementInLayoutId,
      ...this.getElement3.loginMsg
    }, true)
    // 登录状态
    const loginStatus = that.getElement.loginOptions.loginStatus || "1"    
    if (loginStatus == "2") {
      this.content.$changeOptionsEV(100, "opacity", false, null,{
        uid: this.getElement.loginUid,
        elementInLayoutId: this.getElement.loginElementInLayout[4].elementInLayoutId,
        ...this.getElement.loginMsg
      }, true)
      this.content.$changeOptionsEV(100, "opacity", false, null,{
        uid: this.getElement2.loginUid,
        elementInLayoutId: this.getElement2.loginElementInLayout[5].elementInLayoutId,
        ...this.getElement2.loginMsg
      }, true)
      this.content.$changeOptionsEV(100, "opacity", false, null,{
        uid: this.getElement3.loginUid,
        elementInLayoutId: this.getElement3.loginElementInLayout[5].elementInLayoutId,
        ...this.getElement3.loginMsg
      }, true)
    }
  }
  tabClick() {
    const that = this
    $(that.content.$el).find(".tabsContainer .tab").on("click", function () {
      // 用于处理点击tab后是否显示注册按钮出错问题
      setTimeout(() => {
        that.tipsShowHide()
        let activeIndex = that.getElement.loginOptions.activeIndex
        console.log('activeIndex :>>',activeIndex);
        if (activeIndex == 0) { // 手机号登录
          that.registFun(that.getElement,6)
        } else if(activeIndex == 2) { // 机构账户登录
          that.registFun(that.getElement2,4)
        } else if(activeIndex == 3) { // 短信验证码登录
          that.registFun(that.getElement3,4)
          // 隐藏验证码倒计时
          $(`.container_id_${that.getElement3.loginMsg.container_id}-rect_id_${that.getElement3.loginMsg.rect_id}-uid_${that.getElement3.loginUid}-elementInLayoutId_${that.getElement3.loginElementInLayout[6].elementInLayoutId}`).hide()
        }
      }, 100);
    })
  }
  registFun(getElement,index) {
    // 是否显示注册地址
    this.ifShowRegister = this.getElement.loginOptions.ifShowRegister
    // 是否显示注册按钮
    let registText = ""
    if(this.ifShowRegister) {
      registText = "新用户注册"
    }
    this.content.$changeOptionsEV(registText, "content", false, null,{
      uid: getElement.loginUid,
      elementInLayoutId: getElement.loginElementInLayout[index].elementInLayoutId,
      ...getElement.loginMsg
    }, true)
  }
}
export default {
  data() {
    return {
      loginEngineComponentData: new loginEngineComponentClass(this)
    }
  },
  methods: {
    async loginEngineComponentPlugin() {
      await this.loginEngineComponentData.init()
    }
  }
}
